let muxPlayerPromise;
const posterHoldAttached = new WeakSet();

function loadMuxPlayer() {
  if (!muxPlayerPromise) {
    muxPlayerPromise = import('@mux/mux-player').then((mod) => {
      holdPostersUntilPlaying();
      return mod;
    });
  }

  return muxPlayerPromise;
}

function revealPosterHold(wrap) {
  wrap.classList.add('is-playing');
}

function holdPosterUntilPlaying(player) {
  const wrap = player.closest('[data-mux-poster-hold]');
  if (!wrap || wrap.classList.contains('is-playing')) {
    return;
  }

  const reveal = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => revealPosterHold(wrap));
    });
  };

  if (!player.paused && player.currentTime > 0) {
    reveal();
    return;
  }

  if (posterHoldAttached.has(player)) {
    return;
  }

  posterHoldAttached.add(player);

  const onFirstFrame = () => {
    if (player.currentTime > 0) {
      reveal();
      return;
    }

    player.addEventListener('timeupdate', reveal, { once: true });
  };

  player.addEventListener('playing', onFirstFrame, { once: true });
}

function holdPostersUntilPlaying() {
  document.querySelectorAll('[data-mux-poster-hold] mux-player').forEach(holdPosterUntilPlaying);
}

export function initMuxPlayers() {
  holdPostersUntilPlaying();

  const eager = document.querySelectorAll('mux-player[data-load="eager"]');
  if (eager.length) {
    loadMuxPlayer();
  }

  const lazy = document.querySelectorAll('mux-player[data-load="viewport"]');
  if (!lazy.length) {
    return;
  }

  if (!('IntersectionObserver' in window)) {
    loadMuxPlayer();
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) {
          continue;
        }

        io.unobserve(entry.target);
        loadMuxPlayer();
      }
    },
    { rootMargin: '200px' }
  );

  lazy.forEach((el) => io.observe(el));
}
